export default function () {
  if (document.getElementById('static-google-map-app')) {
    // eslint-disable-next-line no-unused-expressions
    import(
      /* webpackChunkName: "static-google-map-app" */ './location/main'
    );
  }
}
